import { Injectable } from '@angular/core';
import { CreateEffectMetadata } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { SciGuaduaHttpRequestHandler } from '@scifamek/guadua';
import { Observable } from 'rxjs';
import { createEntityEffects } from '../../../shared/base';
import {
  CreatePackageCommand,
  GetAllPackagesCommand,
  UpdatePackageCommand,
  UpdateStatusPackageCommand,
} from './package.commands';
import {
  CreatedPackageEvent,
  GotAllPackagesEvent,
  UpdatedPackageEvent,
  UpdatedStatusPackageEvent,
} from './package.events';

@Injectable()
export class PackageEffects {
  prefix = 'package';
  createPackageCommand: Observable<Action<string>> & CreateEffectMetadata;
  getAllPackagesCommand: Observable<Action<string>> & CreateEffectMetadata;
  updatePackageCommand: Observable<Action<string>> & CreateEffectMetadata;
  updateStatusPackageCommand: Observable<Action<string>> & CreateEffectMetadata;

  constructor(private sciGuaduaHttpRequestHandler: SciGuaduaHttpRequestHandler) {
    this.createPackageCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      CreatePackageCommand,
      CreatedPackageEvent,
      this.prefix,
    );
    this.getAllPackagesCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      GetAllPackagesCommand,
      GotAllPackagesEvent,
      this.prefix,
    );
    this.updatePackageCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      UpdatePackageCommand,
      UpdatedPackageEvent,
      this.prefix,
    );
    this.updateStatusPackageCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      UpdateStatusPackageCommand,
      UpdatedStatusPackageEvent,
      this.prefix,
    );
  }
}
